import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const MODEL_LABELS = { chatgpt: "ChatGPT", gemini: "Gemini", claude: "Claude" };

export const ModelSelector = ({ value, onChange, disabled }) => {
  const [models, setModels] = useState([]);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    axios.get(`${API}/ai/models`).then(({ data }) => { if (active) setModels(data); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);

  return (
    <div className="flex items-center gap-3 border-b border-cream-muted bg-cream-secondary px-4 py-2.5" data-testid="ai-model-controls">
      <label htmlFor="ai-model-choice" className="shrink-0 text-xs font-semibold text-ragi-dark" data-testid="ai-model-label">AI model</label>
      <Select value={value} onValueChange={onChange} disabled={disabled || !models.length}>
        <SelectTrigger id="ai-model-choice" aria-label="AI model" aria-busy={!models.length && !failed} className="h-9 min-w-0 flex-1 border-ragi/20 bg-cream text-xs text-ragi-dark" data-testid="ai-model-select">
          <SelectValue><span data-testid="ai-model-current-label">{models.length ? (models.find((entry) => entry.id === value)?.label || "Choose model") : failed ? "Models unavailable" : "Loading models…"}</span></SelectValue>
        </SelectTrigger>
        <SelectContent className="z-[80] bg-cream" data-testid="ai-model-menu">
          {models.map((model) => <SelectItem key={model.id} value={model.id} data-testid={`ai-model-option-${model.id}`}>{model.label}</SelectItem>)}
        </SelectContent>
      </Select>
      {failed && <span role="status" className="text-xs text-terracotta" data-testid="ai-model-load-error">Try again later</span>}
    </div>
  );
};